var exports = {
  "aw": "x31de4314--aba234--slider",
  "jD": "x31de4314--aba234--cont",
  "eu": "x31de4314--aba234--cont--empty",
};

module.exports = exports;
